<template>
    <div class="box">
        <div class="box-list" v-for="item in monthList" :key="item.monthID">
            <div class="box-list-title">
                {{item.monthName}}
            </div>
            <div
                class="box-list-item"
                v-for="item1 in item.bookList"
                :key="item1.bookID"
                @click="gotoAnswer(item1)"
            >
                <div class="box-list-item_name">
                    {{item1.bookName}}
                </div>
                <img class="box-list-item_img" src="https://i.gsxcdn.com/2444694092_ooo3lmcn.png" alt="">
            </div>
        </div>
    </div>
</template>

<script lang="js">
import {Options, Vue} from 'vue-class-component';
import {referenceAnswerList} from '@/api/api';

@Options({
    components: {
    },
    created() {
        this.courseLevel = +this.$route.query.courseLevel || 2;
        this.referenceAnswerList();
    }
})
export default class AnswerList extends Vue {
    courseLevel = 2;
    monthList = [];

    async referenceAnswerList() {
        const res = await referenceAnswerList({
            courseLevel: this.courseLevel
        });
        if (res.code === '0') {
            this.monthList = res.data?.list;
        }
        else {
            this.$toast(res.msg);
        }
    }

    gotoAnswer(item) {
        this.$router.push({
            path: this.courseLevel === 3 ? '/s3answer' : '/answer',
            query: {
                id: item.bookParam,
                courseLevel: this.courseLevel
            }
        });
    }
}
</script>

<style lang="scss" scoped>
.box {
    width: 100vw;
    min-height: 100vh;
    padding-top: .43rem;

    &-list {
        width: 100%;
        padding-left: .43rem;
        padding-bottom: .83rem;
        box-sizing: border-box;

        &-title {
            font-weight: 500;
            font-size: .4rem;
            color: #0B0B0B;
            line-height: .51rem;
            text-align: left;
            font-style: normal;
            margin-bottom: .24rem;
        }

        &-item {
            box-sizing: border-box;
            padding-top: .48rem;
            width: 100%;
            position: relative;

            &_name {
                display: inline-block;
                margin-left: .42rem;
                width: 8.05rem;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-weight: 400;
                font-size: .37rem;
                color: #6A6A6A;
                line-height: .48rem;
                text-align: left;
                font-style: normal;
            }

            &_img {
                width: .64rem;
                height: .64rem;
                position: absolute;
                right: .21rem;
                top: .4rem;
            }
        }

        &-item::after {
            content: "";
            margin-top: .53rem;
            display: block;
            width: 9.6rem;
            height: .01rem;
            background: #F1F1F1;
        }
    }
}

</style>
